import BillOfMaterial from "../models/BillOfMaterial";
import apiClient from '../components/apiClient';

export class BillOfMaterialService {
    static addBillOfMaterial(billOfMaterial: BillOfMaterial) : Promise<BillOfMaterial> {
        return apiClient.post<BillOfMaterial>(`/BillOfMaterials/AddBillOfMaterial`, billOfMaterial).then(res => res.data);
    }

    static getBillOfMaterialByStyleCode(styleCode: string) : Promise<BillOfMaterial[]> {
        return apiClient.get<BillOfMaterial[]>(`/BillOfMaterials/GetBillOfMaterials/${styleCode}`).then(res => res.data);
    }

    static updateBillOfMaterial(billOfMaterial: BillOfMaterial) : Promise<boolean> {
        return apiClient.put<boolean>(`/BillOfMaterials/UpdateBillOfMaterial`, billOfMaterial).then(res => res.data);
    }

    static deleteBillOfMaterial(id: number) : Promise<boolean> {
        return apiClient.delete<boolean>(`/BillOfMaterials/DeleteBillOfMaterial/${id}`).then(res => res.data);
    }

    static copyDetailingPrompts(styleCode: string) : Promise<BillOfMaterial[]> {
        return apiClient.get<BillOfMaterial[]>(`/BillOfMaterials/CopyDetailingPrompts/${styleCode}`).then(res => res.data);
    }
}